// @ts-nocheck
import React, { useEffect, useState } from 'react';
import api from '../services/api';
import notify from '../utils/toast';
import { useI18n } from '../context/I18nContext';

export default function BankAssets() {
    const { lang, t } = useI18n();
    const [tab, setTab] = useState('bank');
    const [banks, setBanks] = useState([]);
    const [recs, setRecs] = useState([]);
    const [assets, setAssets] = useState([]);
    const [currencies, setCurrencies] = useState([]);
    const [bankForm, setBankForm] = useState({ name: '', bank_name: '', account_number: '', branch: '', opening_balance: 0 });
    const [recForm, setRecForm] = useState({ bank_account_id: '', statement_date: new Date().toISOString().slice(0, 10), statement_balance: '' });
    const [assetForm, setAssetForm] = useState({
        code: '', name: '', category: 'equipment', purchase_date: '', purchase_cost: '', residual_value: 0, useful_life_years: 5,
    });
    const [curForm, setCurForm] = useState({ code: '', name: '', symbol: '', exchange_rate: 1, is_base: false });

    const load = () => {
        api.get('/system/bank-accounts').then((r) => setBanks(r.data.data)).catch(() => {});
        api.get('/system/reconciliations').then((r) => setRecs(r.data.data)).catch(() => {});
        api.get('/system/fixed-assets').then((r) => setAssets(r.data.data)).catch(() => {});
        api.get('/system/currencies').then((r) => setCurrencies(r.data.data)).catch(() => {});
    };

    useEffect(() => { load(); }, []);

    const createBank = async (e) => {
        e.preventDefault();
        await api.post('/system/bank-accounts', { ...bankForm, opening_balance: Number(bankForm.opening_balance) });
        setBankForm({ name: '', bank_name: '', account_number: '', branch: '', opening_balance: 0 });
        load();
    };

    const createRec = async (e) => {
        e.preventDefault();
        await api.post('/system/reconciliations', {
            ...recForm,
            statement_balance: Number(recForm.statement_balance),
        });
        load();
    };

    const createAsset = async (e) => {
        e.preventDefault();
        await api.post('/system/fixed-assets', {
            ...assetForm,
            purchase_cost: Number(assetForm.purchase_cost),
            residual_value: Number(assetForm.residual_value),
            useful_life_years: Number(assetForm.useful_life_years),
        });
        setAssetForm({ code: '', name: '', category: 'equipment', purchase_date: '', purchase_cost: '', residual_value: 0, useful_life_years: 5 });
        load();
    };

    const depreciate = async (id) => {
        const res = await api.post(`/system/fixed-assets/${id}/depreciate`);
        alert(`Depreciation: ৳ ${Number(res.data.depreciation_this_run).toLocaleString()}`);
        load();
    };

    const createCur = async (e) => {
        e.preventDefault();
        await api.post('/system/currencies', { ...curForm, exchange_rate: Number(curForm.exchange_rate) });
        setCurForm({ code: '', name: '', symbol: '', exchange_rate: 1, is_base: false });
        load();
    };

    return (
        <div>
            <h4 className="mb-1">{t('bankCurrencyAssets')}</h4>
            <p className="text-muted mb-3">Multi-currency · Bank reconciliation · Fixed asset register</p>

            <div className="btn-group mb-3">
                {['bank', 'recon', 'assets', 'currency'].map((t) => (
                    <button key={t} className={`btn btn-sm text-capitalize ${tab === t ? 'btn-primary' : 'btn-outline-secondary'}`} onClick={() => setTab(t)}>{t === 'recon' ? 'Reconciliation' : t}</button>
                ))}
            </div>

            {tab === 'bank' && (
                <div className="row g-3">
                    <div className="col-md-4">
                        <div className="card table-card"><div className="card-header fw-semibold">Add Bank Account</div>
                            <div className="card-body">
                                <form onSubmit={createBank}>
                                    <input className="form-control form-control-sm mb-2" placeholder="Account name" required value={bankForm.name} onChange={(e) => setBankForm({ ...bankForm, name: e.target.value })} />
                                    <input className="form-control form-control-sm mb-2" placeholder="Bank name" value={bankForm.bank_name} onChange={(e) => setBankForm({ ...bankForm, bank_name: e.target.value })} />
                                    <input className="form-control form-control-sm mb-2" placeholder="Account number" value={bankForm.account_number} onChange={(e) => setBankForm({ ...bankForm, account_number: e.target.value })} />
                                    <input className="form-control form-control-sm mb-2" placeholder="Branch" value={bankForm.branch} onChange={(e) => setBankForm({ ...bankForm, branch: e.target.value })} />
                                    <input type="number" className="form-control form-control-sm mb-2" placeholder="Opening balance" value={bankForm.opening_balance} onChange={(e) => setBankForm({ ...bankForm, opening_balance: e.target.value })} />
                                    <button className="btn btn-primary btn-sm">Save</button>
                                </form>
                            </div>
                        </div>
                    </div>
                    <div className="col-md-8">
                        <div className="card table-card">
                            <div className="table-responsive">
                                <table className="table mb-0">
                                    <thead className="table-light"><tr><th>Name</th><th>Bank</th><th>Account</th><th className="text-end">Balance</th></tr></thead>
                                    <tbody>
                                        {banks.map((b) => (
                                            <tr key={b.id}><td>{b.name}</td><td>{b.bank_name}</td><td>{b.account_number}</td><td className="text-end">৳ {Number(b.current_balance).toLocaleString()}</td></tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            )}

            {tab === 'recon' && (
                <div className="row g-3">
                    <div className="col-md-4">
                        <div className="card table-card"><div className="card-header fw-semibold">New Reconciliation</div>
                            <div className="card-body">
                                <form onSubmit={createRec}>
                                    <select className="form-select form-select-sm mb-2" required value={recForm.bank_account_id} onChange={(e) => setRecForm({ ...recForm, bank_account_id: e.target.value })}>
                                        <option value="">Bank account</option>
                                        {banks.map((b) => <option key={b.id} value={b.id}>{b.name}</option>)}
                                    </select>
                                    <input type="date" className="form-control form-control-sm mb-2" value={recForm.statement_date} onChange={(e) => setRecForm({ ...recForm, statement_date: e.target.value })} />
                                    <input type="number" className="form-control form-control-sm mb-2" placeholder="Statement balance" required value={recForm.statement_balance} onChange={(e) => setRecForm({ ...recForm, statement_balance: e.target.value })} />
                                    <button className="btn btn-primary btn-sm">Match</button>
                                </form>
                            </div>
                        </div>
                    </div>
                    <div className="col-md-8">
                        <div className="card table-card">
                            <div className="table-responsive">
                                <table className="table table-sm mb-0">
                                    <thead className="table-light"><tr><th>Date</th><th>Statement</th><th>Book</th><th>Diff</th><th>Status</th></tr></thead>
                                    <tbody>
                                        {recs.map((r) => (
                                            <tr key={r.id}>
                                                <td>{r.statement_date}</td>
                                                <td>{Number(r.statement_balance).toLocaleString()}</td>
                                                <td>{Number(r.book_balance).toLocaleString()}</td>
                                                <td>{Number(r.difference).toLocaleString()}</td>
                                                <td><span className={`badge bg-${r.status === 'matched' ? 'success' : 'warning'}`}>{r.status}</span></td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            )}

            {tab === 'assets' && (
                <div className="row g-3">
                    <div className="col-md-4">
                        <div className="card table-card"><div className="card-header fw-semibold">Register Asset</div>
                            <div className="card-body">
                                <form onSubmit={createAsset}>
                                    <input className="form-control form-control-sm mb-2" placeholder="Code" required value={assetForm.code} onChange={(e) => setAssetForm({ ...assetForm, code: e.target.value })} />
                                    <input className="form-control form-control-sm mb-2" placeholder="Name" required value={assetForm.name} onChange={(e) => setAssetForm({ ...assetForm, name: e.target.value })} />
                                    <select className="form-select form-select-sm mb-2" value={assetForm.category} onChange={(e) => setAssetForm({ ...assetForm, category: e.target.value })}>
                                        {['building', 'machinery', 'vehicle', 'furniture', 'equipment', 'land', 'other'].map((c) => <option key={c} value={c}>{c}</option>)}
                                    </select>
                                    <input type="date" className="form-control form-control-sm mb-2" value={assetForm.purchase_date} onChange={(e) => setAssetForm({ ...assetForm, purchase_date: e.target.value })} />
                                    <input type="number" className="form-control form-control-sm mb-2" placeholder="Purchase cost" required value={assetForm.purchase_cost} onChange={(e) => setAssetForm({ ...assetForm, purchase_cost: e.target.value })} />
                                    <input type="number" className="form-control form-control-sm mb-2" placeholder="Residual value" value={assetForm.residual_value} onChange={(e) => setAssetForm({ ...assetForm, residual_value: e.target.value })} />
                                    <input type="number" className="form-control form-control-sm mb-2" placeholder="Useful life (years)" value={assetForm.useful_life_years} onChange={(e) => setAssetForm({ ...assetForm, useful_life_years: e.target.value })} />
                                    <button className="btn btn-primary btn-sm">Save</button>
                                </form>
                            </div>
                        </div>
                    </div>
                    <div className="col-md-8">
                        <div className="card table-card">
                            <div className="table-responsive">
                                <table className="table table-sm mb-0">
                                    <thead className="table-light"><tr><th>Code</th><th>Name</th><th>Cost</th><th>Accum. Dep.</th><th>Book Value</th><th></th></tr></thead>
                                    <tbody>
                                        {assets.map((a) => (
                                            <tr key={a.id}>
                                                <td>{a.code}</td><td>{a.name}</td>
                                                <td>{Number(a.purchase_cost).toLocaleString()}</td>
                                                <td>{Number(a.accumulated_depreciation).toLocaleString()}</td>
                                                <td>{Number(a.book_value).toLocaleString()}</td>
                                                <td><button className="btn btn-sm btn-outline-primary" onClick={() => depreciate(a.id)} disabled={a.status === 'fully_depreciated'}>Depreciate</button></td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            )}

            {tab === 'currency' && (
                <div className="row g-3">
                    <div className="col-md-4">
                        <div className="card table-card"><div className="card-header fw-semibold">Add Currency</div>
                            <div className="card-body">
                                <form onSubmit={createCur}>
                                    <input className="form-control form-control-sm mb-2" placeholder="Code (USD)" required maxLength={3} value={curForm.code} onChange={(e) => setCurForm({ ...curForm, code: e.target.value.toUpperCase() })} />
                                    <input className="form-control form-control-sm mb-2" placeholder="Name" required value={curForm.name} onChange={(e) => setCurForm({ ...curForm, name: e.target.value })} />
                                    <input className="form-control form-control-sm mb-2" placeholder="Symbol" value={curForm.symbol} onChange={(e) => setCurForm({ ...curForm, symbol: e.target.value })} />
                                    <input type="number" step="0.0001" className="form-control form-control-sm mb-2" placeholder="Rate to base" value={curForm.exchange_rate} onChange={(e) => setCurForm({ ...curForm, exchange_rate: e.target.value })} />
                                    <div className="form-check mb-2">
                                        <input className="form-check-input" type="checkbox" checked={curForm.is_base} onChange={(e) => setCurForm({ ...curForm, is_base: e.target.checked })} id="baseCur" />
                                        <label className="form-check-label" htmlFor="baseCur">Base currency</label>
                                    </div>
                                    <button className="btn btn-primary btn-sm">Save</button>
                                </form>
                            </div>
                        </div>
                    </div>
                    <div className="col-md-8">
                        <div className="card table-card">
                            <div className="table-responsive">
                                <table className="table mb-0">
                                    <thead className="table-light"><tr><th>Code</th><th>Name</th><th>Symbol</th><th>Rate</th><th>Base</th></tr></thead>
                                    <tbody>
                                        {currencies.map((c) => (
                                            <tr key={c.id}><td>{c.code}</td><td>{c.name}</td><td>{c.symbol}</td><td>{c.exchange_rate}</td><td>{c.is_base ? '★' : ''}</td></tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
}
